module.exports = __webpack_public_path__ + "assets/icon-facebook.9b7d1238.svg";